import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Logistica from './Logistica';

const Router = () => (
	<HashRouter>
		<Switch>
			<Route exact path="/:joly" component={Logistica} />
			<Route exact path="/" component={Logistica} />
		</Switch>
	</HashRouter>
);

export default Router;




// WEBPACK FOOTER //
// ./src/components/Router.js